import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Scrollable } from '@sorare/core/src/atoms/navigation/Scrollable';
import { BodyL } from '@sorare/core/src/atoms/typography';
import { BrandingVideo } from '@sorare/core/src/components/content/BrandingVideo';
import { HELP } from '@sorare/core/src/constants/__generated__/routes';
import { FRONTEND_ASSET_HOST } from '@sorare/core/src/constants/assets';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { glossary } from '@sorare/core/src/lib/glossary';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import {
  HowToPlayCardsTile,
  HowToPlayGWTile,
  HowToPlayRosterTile,
  HowToPlayScoringTile,
} from 'components/homepage/Overview/HowToPlay/ContentTiles';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: var(--triple-unit);
  padding: var(--triple-unit) var(--intermediate-unit);
  & > * {
    max-width: 100%;
  }

  @media ${tabletAndAbove} {
    gap: var(--quadruple-unit);
    padding: var(--quadruple-unit);
  }
`;
const BlockTitle = styled.h2`
  font-family: var(--brand-font);
  font-size: var(--fs-landing-title);
  text-transform: uppercase;
`;
const Video = styled(BrandingVideo)`
  border-radius: var(--triple-unit);
  max-width: 1180px;
`;

const ViewGuideButton = styled.a`
  background-color: var(--c-nd-900);
  border-radius: var(--quadruple-unit);
  font-size: var(--t-14);
  color: var(--c-black);
  padding: var(--double-unit) var(--triple-unit);
  width: 100%;
  text-align: center;

  &:visited {
    color: var(--c-black);
  }
  &:hover,
  &:focus {
    background-color: var(--c-nd-800);
  }

  @media ${tabletAndAbove} {
    width: 30%;
  }
`;

const HowToPlayPage = () => {
  const isLaptopAndAbove = useIsLaptop();
  return (
    <Wrapper>
      <div className="text-center">
        <BlockTitle>
          <FormattedMessage {...glossary.howToPlay} />
        </BlockTitle>
        <BodyL>
          <FormattedMessage
            id="sorare.baseball.howToPlay.subtitle"
            defaultMessage="Watch the 101 video to find out how to get started on Sorare."
          />
        </BodyL>
      </div>
      <Video
        src={`${FRONTEND_ASSET_HOST}/videos/mlb_landing_tutorial.mp4`}
        mobileSrc={`${FRONTEND_ASSET_HOST}/videos/mlb_landing_tutorial.mp4`}
        poster="https://frontend-assets.sorare.com/baseball/how-to-play/video-thumbnail.png"
        aria-label="Sorare MLB 101"
      />
      <ViewGuideButton href={HELP}>
        <FormattedMessage
          id="HowToPlay.View"
          defaultMessage="View Complete MLB Manager Guide"
        />
      </ViewGuideButton>

      <Scrollable itemToDisplay={isLaptopAndAbove ? 3 : 1} overhang withMask>
        <HowToPlayCardsTile />
        <HowToPlayRosterTile />
        <HowToPlayScoringTile />
        <HowToPlayGWTile />
      </Scrollable>
    </Wrapper>
  );
};

export default HowToPlayPage;
